import React, { useState } from 'react';
import { adminRejectedApplication } from '../../../../utils/enums';
import { viewNotification } from '../../../API/dashboard';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Link from '@material-ui/core/Link';
import Dialog from '@material-ui/core/Dialog';
import InsufficientSales from './InsufficientSales';
import SellerQuality from './SellerQuality';
import IncompleteData from './IncompleteData';
import FastExposure from './FastExposure';
import UnsupportedGrowth from './UnsupportedGrowth';
import NegativeGrowth from './NegativeGrowth';
import LowMargin from './LowMargin';
import Other from './Other';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';

const useStyles = makeStyles((theme) => ({
  viewResponse: {
    fontSize: 'inherit',
    padding: 0,
  },
  mailLogo: {
    fontSize: '70px',
    alignSelf: 'center',
  },
  notification: {
    marginBottom: theme.spacing(3),
  },
  closeButton: {
    position: 'absolute',
    left: 0,
  },
  dialogAction: { alignSelf: 'center' },
  button: {
    minWidth: 175,
  },
}));

export default function ShowRejectNotification(props) {
  const classes = useStyles();
  const { notification, rejectNotifications, setRejectNotifications } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const storeName = notification?.c_name;

  function onCloseRejectDialog() {
    setOpenDialog(false);
  }

  async function onDoNotShowThisNotificationAnyMore() {
    setLoading(true);
    await viewNotification(notification.id);
    onCloseRejectDialog();
    setRejectNotifications(
      rejectNotifications.filter((r, i) => r.id !== notification.id),
    );
    setLoading(false);
  }

  return (
    <>
      <li className={classes.notification}>
        <Link
          className={classes.viewResponse}
          onClick={() => {
            setOpenDialog(true);
          }}
        >
          We’ve responded to your recent application. View Response {'>'}
        </Link>
      </li>
      <Dialog open={openDialog} fullWidth={true}>
        <IconButton
          onClick={onCloseRejectDialog}
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>

        <MailOutlineIcon className={classes.mailLogo} />

        {notification.admin_rejection_reason ===
          adminRejectedApplication.InsufficientSales && (
          <InsufficientSales
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.SellerQuality && (
          <SellerQuality
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.IncompleteData && (
          <IncompleteData
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.FastExposure && (
          <FastExposure
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.UnsupportedGrowth && (
          <UnsupportedGrowth
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.NegativeGrowth && (
          <NegativeGrowth
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.LowMargin && (
          <LowMargin
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        {notification.admin_rejection_reason ===
          adminRejectedApplication.Other && (
          <Other
            loading={loading}
            closeDialog={onCloseRejectDialog}
            storeName={storeName}
          />
        )}

        <DialogActions className={classes.dialogAction}>
          <LoadingButton
            color="default"
            className={classes.button}
            loading={loading}
            onClick={onDoNotShowThisNotificationAnyMore}
          >
            <b>Don't show this message again</b>
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
